<template>
    <div class="container">
        <div class="visual">
            <img class="d-md-none" :src="visual.mobileSrc" alt="">
            <img class="d-none d-md-block" :src="visual.desktopSrc" alt="">
        </div>
        <div class="bloc-text bg-dark">
            <div class="inside-bloc-text text-white text-center p-2">
                <p v-if="text" class="h3 mb-0" v-html="text" />
                <p class="h3 mb-0" v-html="subtitle" />
                <template v-if="advantages">
                    <p class="py-0 mb-0">
                        <strong class="icon-rewards me-1 font-size-34" /><strong class="font-size-40" v-html="advantages" />
                    </p>
                    <p class="small mb-0 pt-0">
                        <small class="ps-3">{{ messages.recoveryText }}</small>
                        <small v-if="bonusAmountInCents > 0" class="ps-4">{{ messages.bonusText }}</small>
                    </p>
                </template>
                <ob1-boutons
                    class="mt-2"
                    :is-secondary="true"
                    :is-inverse="true"
                    :label="messages.ctaLabel"
                    data-bs-toggle="modal"
                    :data-bs-target="'#' + simulatorModalId"
                    data-oevent-label=""
                    data-oevent-action=""
                    data-oevent-category=""
                />
                <div v-if="recoveryModalId" class="text-center">
                    <ob1-liens
                        class="mt-1 d-inline text-white"
                        is-button
                        :with-arrow="true"
                        :modal-id="recoveryModalId"
                        data-bs-toggle="modal"
                        :text="messages.linkLabel"
                        data-oevent-label=""
                        data-oevent-category=""
                        data-oevent-action=""
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "MobileRecovery",
    props: {
        recoveryAmountInCents: {
            type: Number,
            default: null
        },
        recoveryDeviceModel: {
            type: String,
            default: null
        },
        manualEstimation: {
            type: Boolean,
            default: null
        },
        bonusAmountInCents: {
            type: Number,
            default: null
        },
        simulatorModalId: {
            type: String,
            required: true
        },
        recoveryModalId: {
            type: String,
            default: undefined
        },
        messages: {
            type: Object,
            required: true
        },
        visual: {
            type: Object,
            required: true
        }
    },
    computed: {
        subtitle() {
            if (!this.recoveryDeviceModel) {
                return this.messages.prospectSubtitle;
            } else if (this.recoveryAmountInCents > 0) {
                let model = "<span class=\"text-primary\">" + this.recoveryDeviceModel + "</span>";
                if (this.manualEstimation === true) {
                    return this.messages.estimatedSubtitle + model;
                } else {
                    return this.messages.identifiedSubtitle + model;
                }
            } else {
                return this.messages.recyclingSubtitle;
            }
        },
        text() {
            if (!this.recoveryDeviceModel || (this.manualEstimation === true && this.recoveryAmountInCents > 0)) {
                return undefined;
            } else if (this.recoveryAmountInCents > 0) {
                return this.messages.identifiedText + " " + this.formatAmount(this.recoveryAmountInCents);
            } else {
                return this.recoveryDeviceModel;
            }
        },
        advantages() {
            if (this.manualEstimation === true && this.recoveryAmountInCents > 0) {
                let advantages = this.formatAmount(this.recoveryAmountInCents);
                if (this.bonusAmountInCents > 0) {
                    advantages += " + " + this.formatAmount(this.bonusAmountInCents);
                }
                return "<span class=\"text-primary\">" + advantages + "</span>";
            } else {
                return undefined;
            }
        }
    },
    methods: {
        formatAmount: function (amountInCents) {
            if (amountInCents) {
                return PriceFormatter.formatEurosWithSpace(amountInCents / 100, false).toString();
            } else {
                return null;
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.container {
    display: flex;
    flex-direction: column; /* Par défaut, les divs sont l'une au-dessus de l'autre */
    align-items: center;
    padding: 0;
}

.visual {
    width: 100%; /* Occupe toute la largeur en mode mobile */
}

.visual img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Permet de zoomer sur l'image sans la déformer */
}

.bloc-text {
    width: 100%; /* Occupe toute la largeur en mode mobile */
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .container {
        flex-direction: row; /* Les divs sont côte à côte en mode desktop */
        align-items: stretch; /* Étire les divs pour qu'elles aient la même hauteur */
    }

    .visual {
        flex: 0 0 40%; /* 40% de la largeur */
    }

    .bloc-text {
        display: flex;
        align-items: center;
    }

    .inside-bloc-text {
        width: 100%;
    }
}

</style>
